import { ReactNode } from 'react'
import Supplier from './supplier'
import Lander from './Lander'
import useHook from './hooks'
import styles from './styles.module.scss'
import { Tabs } from 'antd'
import { OrderType } from '../../tools/public'
export default function OrderAssurance() {
  const { changeOrder, checkedOrderKey, permissionList } = useHook()
  const menuList: {
    key: OrderType
    component: ReactNode
    title: string
  }[] = []

  if (permissionList.length === 1 && permissionList.includes('电商供应商')) {
    menuList.push({
      key: 'CUSTOMER',
      component: <Lander />,
      title: '落地商订单',
    })
  }

  if (permissionList.length === 1 && permissionList.includes('自营供应商')) {
    menuList.push({
      key: 'SUPPLIER',
      component: <Supplier />,
      title: '供应商订单',
    })
  }

  if (permissionList.length === 0 || permissionList.length === 2) {
    menuList.push(
      {
        key: 'SUPPLIER',
        component: <Supplier />,
        title: '供应商订单',
      },
      {
        key: 'CUSTOMER',
        component: <Lander />,
        title: '落地商订单',
      },
    )
  }

  const getMainContent = (key: string) => {
    return menuList.find((item) => item.key === key)?.component
  }

  return (
    <div className={styles.main}>
      <Tabs
        type="card"
        activeKey={checkedOrderKey}
        onTabClick={(keyname) => {
          changeOrder(keyname)
        }}
      >
        {menuList.map((item) => {
          return (
            <Tabs.TabPane tab={item.title} key={item.key}>
              {getMainContent(item.key)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}
import { ReactNode } from 'react'
import Supplier from './supplier'
import Lander from './Lander'
import useHook from './hooks'
import styles from './styles.module.scss'
import { Tabs } from 'antd'
import { OrderType } from '../../tools/public'
export default function OrderAssurance() {
  const { changeOrder, checkedOrderKey, permissionList } = useHook()
  const menuList: {
    key: OrderType
    component: ReactNode
    title: string
  }[] = []

  if (permissionList.length === 1 && permissionList.includes('电商供应商')) {
    menuList.push({
      key: 'CUSTOMER',
      component: <Lander />,
      title: '落地商订单',
    })
  }

  if (permissionList.length === 1 && permissionList.includes('自营供应商')) {
    menuList.push({
      key: 'SUPPLIER',
      component: <Supplier />,
      title: '供应商订单',
    })
  }

  if (permissionList.length === 0 || permissionList.length === 2) {
    menuList.push(
      {
        key: 'SUPPLIER',
        component: <Supplier />,
        title: '供应商订单',
      },
      {
        key: 'CUSTOMER',
        component: <Lander />,
        title: '落地商订单',
      },
    )
  }

  const getMainContent = (key: string) => {
    return menuList.find((item) => item.key === key)?.component
  }

  return (
    <div className={styles.main}>
      <Tabs
        type="card"
        activeKey={checkedOrderKey}
        onTabClick={(keyname) => {
          changeOrder(keyname)
        }}
      >
        {menuList.map((item) => {
          return (
            <Tabs.TabPane tab={item.title} key={item.key}>
              {getMainContent(item.key)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}
